import { useProfiles } from '../../contexts/ProfilesContext';

export const UserSelect = ({ value, onChange, exclude = [], label }) => {
  const { profiles } = useProfiles();
  return (
    <div>
      {label && <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>}
      <select value={value} onChange={e => onChange(e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option value="">Select person...</option>
        {profiles.filter(p => p.is_active && !exclude.includes(p.email)).map(p => <option key={p.email} value={p.email}>{p.name}</option>)}
      </select>
    </div>
  );
};
